import styled from 'styled-components';

export const TaskHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
`;

export const TaskButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const TaskHeaderTitle = styled.h1`
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
